export default (radValue, precision = 2) => `${((180 * radValue) / Math.PI).toFixed(precision)}°`;
